module.exports = __webpack_public_path__ + "static/matrix.7cc14e59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/matrix.jpg
// module id = 480
// module chunks = 114276838955818